<template>
  <div class="card" v-show="currentCardId == 'en-address'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>住所を入力</h2>
        <p>住所を入力しましょう</p>
      </div>
      <div class="card-content">
        <div class="edit-form">
          <div class="edit-form-item">
            <div class="item-name">住所</div>
            <div class="item-body">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6 }"
                placeholder="1-2-3 Shibuya, Shibuya-ku, Tokyo 150-0002, Japan"
                title="住所"
                v-model="formatData.address"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useEnglishResumeFormatData } from '@/composables/format-edit/useEnglishResumeFormatData'

defineProps<{
  currentCardId?: string
}>()

const formatData = useEnglishResumeFormatData()
</script>
